var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpArrowGreen = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99497 0.206096C3.72161 -0.0695327 3.27839 -0.0695327 3.00503 0.206096L0.205025 3.02926C-0.0683418 3.30488 -0.0683418 3.75177 0.205025 4.02739C0.478392 4.30302 0.921608 4.30302 1.19497 4.02739L2.80066 2.40843V7.29485C2.80066 7.68464 3.11406 8.00064 3.50066 8.00064C3.88726 8.00064 4.20066 7.68464 4.20066 7.29485V2.40976L5.80503 4.02739C6.07839 4.30302 6.52161 4.30302 6.79497 4.02739C7.06834 3.75177 7.06834 3.30488 6.79497 3.02926L3.99497 0.206096Z",
    fill: "#13A846"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpArrowGreen);
export default ForwardRef;